function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { PRINTER_DRIVER_TYPE } from "@dpdgroupuk/mydpd-enums";
import AbstractDriver from "./AbstractPrinterDriver";
import printJS from "./printJS";

class BrowserHtmlDriver extends AbstractDriver {
  async configure() {// nothing to check and configure
  }

  async print(labels) {
    return printJS({
      printable: labels,
      type: "raw-html"
    });
  }

}

_defineProperty(BrowserHtmlDriver, "DRIVER_TYPE", PRINTER_DRIVER_TYPE.NONE);

export default BrowserHtmlDriver;